
import { defineComponent } from "vue";
import { ICourseGroupsModel, ICoursesModel, IAcademicYearModel, ITeachersModel, IStudentsModel } from "@/interfaces/modules/";
import CourseGroupsService from "@/api/Aula/CourseGroupsService";
import CoursesService from "@/api/Aula/CoursesSevice";
import TeachserService from "@/api/Aula/TeachersService";
import StudenService from "@/api/Aula/StudentsService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import store from "@/store";
import { SHOW_PRESCHOOL } from "@/enums";

export default defineComponent({
  name: "GroupsContent",
  props: ['record'],
  data() {
    return {
      Courses: [] as ICoursesModel[],
      academicYears: [] as IAcademicYearModel[],
      teachers: [] as ITeachersModel[],
      students: [] as IStudentsModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ICourseGroupsModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Name", label: "Grupo", sortable: false },
          { key: "AcademicYearName", label: "Año académico", sortable: false },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as ICourseGroupsModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): ICourseGroupsModel[] {
      const q = (this.table.filters.search ?? '').toLowerCase().trim();
      const selectedCourseId = Number(this.$props.record.Id ?? 0); // e.g. from a <select>

      return this.table.records.filter((item: ICourseGroupsModel) => {
        // 1) Filter by CourseId if one is selected
        if (selectedCourseId && item.CourseId !== selectedCourseId) return false;

        // 2) If no search, it's already a match
        if (!q) return true;

        // 3) Text search (same as you had)
        const courseName = this.getCourseName(item.CourseId) ?? '';
        const yearName = this.getAcademicYearName(item.AcademicYearId) ?? '';
        return [
          item.Name,
          item.Description,
          courseName,
          yearName,
          (item as any).CreatedByName,
          (item as any).ModifiedByName,
        ]
          .filter(Boolean)
          .some(v => String(v).toLowerCase().includes(q));
      });
    }
    ,
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    getCourseName(id?: number) {
      if (!id) return "";
      const found = this.Courses.find((c) => c.Id === id);
      return found?.Name || "";
    },
    getAcademicYearName(id?: number) {
      if (!id) return "";
      const found = this.academicYears.find((y) => y.Id === id);
      return found?.Name || "";
    },
    async load() {
      this.table.loading = true;
      // Lookups
      this.Courses = await CoursesService.GetCourses(SHOW_PRESCHOOL.No);
      this.academicYears = await AcademicYearService.GetAcademicYears();
      this.teachers = await TeachserService.GetTeachers();
      this.students = await StudenService.GetStudents();
      // Records
      this.table.records = await CourseGroupsService.GetCourseGroups();
      this.table.loading = false;
    },
    async edit(data: ICourseGroupsModel) {
      this.form.record = await CourseGroupsService.GetCourseGroupsbyId({ Id: data.Id });
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = {
        CourseId: this.$props.record.Id,
        Enable: true,
      } as ICourseGroupsModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await CourseGroupsService.PostCourseGroups(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
